import { render } from "./SaveToEbmModal.vue?vue&type=template&id=aaa65660&scoped=true"
import script from "./SaveToEbmModal.vue?vue&type=script&lang=js"
export * from "./SaveToEbmModal.vue?vue&type=script&lang=js"

import "./SaveToEbmModal.vue?vue&type=style&index=0&id=aaa65660&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaa65660"]])

export default __exports__